// extracted by mini-css-extract-plugin
export default {"textField":"InviteUser_textField__-flFk","select":"InviteUser_select__RNBd7","form":"InviteUser_form__kfs1M"};